// extracted by mini-css-extract-plugin
export default {"container":"Main_container__U7QH0","list":"Main_list__MZ05g"};